module.exports = __webpack_public_path__ + "96621d3c37d96ad3bf792fcc848d912f.svg";